<template>
  <section class="library-search-bar" @keyup.enter="searchResults">
    <input
      type="text"
      class="library-search-bar-input"
      v-model="searchText"
      :placeholder="$t('SEARCH_PLACEHOLDER')"
    />
    <button class="search-button" @click="searchResults"></button>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'search-bar',

  data () {
    return {
      searchText: null
    }
  },
  computed: {
    ...mapState({
      searchWord: state => state.collections.searchWord
    })
  },
  mounted () {
    this.searchText = this.searchWord
  },
  watch: {
    searchWord: function () {
      this.searchText = this.searchWord
    }
  },
  methods: {
    searchResults () {
      if (!this.searchText) return
      this.$store.dispatch('setSearchWord', this.searchText)
      this.$store.dispatch('searchResults').then(() => {
        if (this.$route.name !== 'searchResult') {
          this.$router.push({ name: 'searchResult', query: { searchText: this.searchText, filters: this.$route.query.filters } })
        } else this.$router.push({ query: { searchText: this.searchText, filters: this.$route.query.filters } })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .library-search-bar{
    .search-button{
      &:after {
        background-image: url('../assets/images/search_grey_icon.svg');
      }
    }
    &:hover, &:focus, &:focus-within{
      .search-button{
        &:after{
          background-image: url('../assets/images/search_icon.svg');
        }
      }
    }
  }
</style>
